/**
 * @generated SignedSource<<ce2852f32cb1b5293fb4f73d27db293c>>
 * @relayHash bd2d61cdca16378a4f1f566700b1fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CollabPermissionTokenQuery$variables = {
  contentId: string;
  draftShareId?: string | null | undefined;
};
export type CollabPermissionTokenQuery$data = {
  readonly collabToken: {
    readonly token: string;
  } | null | undefined;
};
export type CollabPermissionTokenQuery = {
  response: CollabPermissionTokenQuery$data;
  variables: CollabPermissionTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "draftShareId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "draftShareId",
        "variableName": "draftShareId"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "CollabTokenResponse",
    "kind": "LinkedField",
    "name": "collabToken",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "token"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CollabPermissionTokenQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CollabPermissionTokenQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bd2d61cdca16378a4f1f566700b1fb56",
    "id": "5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69",
    "metadata": {},
    "name": "CollabPermissionTokenQuery",
    "operationKind": "query",
    "text": "query CollabPermissionTokenQuery($contentId:ID!,$draftShareId:String){collabToken(id:$contentId,draftShareId:$draftShareId){token}}"
  }
};
})();

(node as any).hash = "f88c8dd0f4e61065305cc9c5b9a3253b";

export default node;
